import { render } from "./TransitionExpand.vue?vue&type=template&id=d31022d2&scoped=true&ts=true"
import script from "./TransitionExpand.vue?vue&type=script&lang=ts"
export * from "./TransitionExpand.vue?vue&type=script&lang=ts"

import "./TransitionExpand.vue?vue&type=style&index=0&id=d31022d2&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d31022d2"]])

export default __exports__